import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { CodeBenchv2 } from '@codametrix/shared-views';
import { ServiceDesk } from './service-desk';
import { useSelector, useDispatch } from 'react-redux';
import { PatientEncounterGradeBenchColumnsv2, uiActions, codeBenchActions, commonEnums } from '@codametrix/ui-common';
const BenchMode = commonEnums.BenchMode;
const enabled = {
    value: true,
    reasons: []
};
const onCapability = {
    on: enabled,
    actionable: enabled
};
const ServiceDeskAndGradeBench = (props)=>{
    const { params = {} } = props.match ?? {};
    const { UIView } = useSelector((state)=>{
        return state.ampUI;
    });
    const dispatch = useDispatch();
    const childRef = useRef(null);
    const codeBenchPanelData = {
        ...props.detailProps,
        capabilities: {
            ...props.detailProps.capabilities,
            capabilities: {
                ...props.detailProps.capabilities.capabilities,
                attachDocs: {
                    on: false
                },
                improvements: {
                    on: false
                },
                coderNotes: {
                    on: false
                },
                versionProcess: {
                    on: false
                },
                statusDescription: {
                    on: false
                },
                actionMenu: {
                    on: false
                },
                submitCase: onCapability
            }
        },
        propertyConfig: PatientEncounterGradeBenchColumnsv2,
        gradeableInvoices: props.detailProps.gradeableInvoices
    };
    const detailProps = {
        UIView,
        ...codeBenchPanelData,
        ...props.detailMethods
    };
    const listProps = {
        ...props.listProps,
        ...props.listMethods
    };
    const [isDetailOpen, setIsDetailOpen] = useState(true);
    const handleSelection = (item)=>{
        setIsDetailOpen(true);
    };
    useEffect(()=>{
        if (params.id === undefined && childRef?.current?.refreshContent) {
            childRef.current.refreshContent();
        }
        setIsDetailOpen(params.id !== undefined);
    }, [
        params.id
    ]);
    useEffect(()=>{
        dispatch(uiActions.setAmplifyView());
        dispatch(uiActions.setStandaloneMode());
        dispatch(codeBenchActions.setBenchMode(BenchMode.GRADE));
        return ()=>{
            dispatch(uiActions.setAutomateView());
        };
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: {
                    display: isDetailOpen ? 'none' : 'block'
                },
                children: /*#__PURE__*/ _jsx(ServiceDesk, {
                    ...listProps,
                    childRef: childRef,
                    onSelection: handleSelection
                })
            }),
            isDetailOpen ? /*#__PURE__*/ _jsx(CodeBenchv2, {
                ...detailProps,
                match: props.match,
                benchMode: BenchMode.GRADE
            }) : null
        ]
    });
};
export { ServiceDeskAndGradeBench };
